export default __webpack_public_path__ + "static/media/pantone-red-icon.3d825f05.svg";